module.exports = __webpack_public_path__ + "static/inter-400.latin-8f100c625d4b09af0e67f2294f6c465f.woff2";